module.exports = __webpack_public_path__ + "static/media/004.504fff4b.jpg";